// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cookieBtn{margin:0 15px}.burgerBtn{margin-top:0;margin-bottom:0;margin-left:15px}.searchBtn{left:50px !important;font-size:15px;margin-bottom:2px}.logo{text-align:center}.downloadBtn{display:inline;margin-right:6px}", ""]);
// Exports
module.exports = exports;
